export default __webpack_public_path__ + "static/media/EventReg-Corporate.2851f441.svg";